import apiHeader from "@/helpers/apiHeader";

const natoGroupService = {
  list(params) {
    return apiHeader.get("dictionary/nato", { params });
  },
  create(data) {
    return apiHeader.post("dictionary/nato", data);
  },
  detail(id) {
    return apiHeader.get(`dictionary/nato/${id}`);
  },
  patch(id, data) {
    return apiHeader.patch(`dictionary/nato/${id}`, data);
  },
  delete(id) {
    return apiHeader.delete(`dictionary/nato/${id}`);
  },
};
export default natoGroupService;
